// extracted by mini-css-extract-plugin
export var active = "Tab_active__qDb4c";
export var button = "Tab_button__zl941";
export var onlyTab = "Tab_onlyTab__VkN-f";